<template>
  <path
    d="M11.4 1.02017C6.62 1.33017 3 5.52017 3 10.3102V17.0002C3 18.6602 4.34 20.0002 6 20.0002H7C8.1 20.0002 9 19.1002 9 18.0002V14.0002C9 12.9002 8.1 12.0002 7 12.0002H5V10.2902C5 6.45017 7.96 3.11017 11.79 3.00017C15.76 2.89017 19 6.06017 19 10.0002V12.0002H17C15.9 12.0002 15 12.9002 15 14.0002V18.0002C15 19.1002 15.9 20.0002 17 20.0002H18C19.66 20.0002 21 18.6602 21 17.0002V10.0002C21 4.83017 16.64 0.680174 11.4 1.02017Z"
  />
</template>
